export default function blogCategories(data) {
  return data.map(category => {
    let value = category.name.toLowerCase().replace(' ', '');
    return {
      value,
      label: category.name,
    };
  });
}
